import Component from '../core/Component';
import $ from 'jquery';
import Ps from 'perfect-scrollbar';

export default class LoadMore extends Component
{
    constructor($element)
    {
        super($element);
    }

    prepare()
    {
        Ps.initialize(this.element, {suppressScrollX: true});
    }
}


// WEBPACK FOOTER //
// ./components/Scrollbar.js